function hideDisabledLeathers(root) {
  // Option 2 = Leather in your setup
  const leatherFieldset = root.querySelector('fieldset[data-index="option2"]');
  if (!leatherFieldset) return;

  leatherFieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
    const label = input.nextElementSibling;
    if (!label || label.tagName !== 'LABEL') return;
    label.classList.toggle('is-hidden', input.disabled);
  });
}

function getArrangementMode(root) {
  const fs = root.querySelector('fieldset[data-index="option2"]');
  if (!fs) return 'none';
  if (fs.querySelector('input[type="checkbox"][data-option-value-id]')) return 'multi';
  if (fs.querySelector('input[type="radio"][data-option-value-id]')) return 'single';
  return 'none';
}

function getArrangementInputs(root) {
  return Array.from(
    root.querySelectorAll('fieldset[data-index="option2"] input[data-option-value-id]')
  );
}

function getSelectedArrangementIds(root) {
  const mode = getArrangementMode(root);

  if (mode === 'multi') {
    return new Set(
      Array.from(
        root.querySelectorAll(
          'fieldset[data-index="option2"] input[type="checkbox"][data-option-value-id]:checked'
        )
      )
        .map((i) => i.dataset.optionValueId)
        .filter(Boolean)
    );
  }

  if (mode === 'single') {
    const checked = root.querySelector(
      'fieldset[data-index="option2"] input[type="radio"][data-option-value-id]:checked'
    );
    return new Set(checked?.dataset.optionValueId ? [checked.dataset.optionValueId] : []);
  }

  return new Set();
}

function getSelectedGradePrefix(root) {
  const gradeValue =
    root.querySelector('fieldset[data-index="option1"] input[type="radio"]:checked')?.value || '';
  // pull first 2 digits anywhere in the grade label
  const m = gradeValue.match(/(\d{2})/);
  return m ? m[1] : null;
}

function updateLeatherPreview(root) {
  const fs = root.querySelector('[data-leather-picker]');
  if (!fs) return;

  const checked = fs.querySelector('input[type="radio"]:checked');
  if (!checked) return;

  const swatchLabel = checked.nextElementSibling; // label for the chosen leather
  const preview = fs.querySelector('[data-leather-preview]');
  const display = fs.querySelector('[data-leather-display]');

  if (display) display.textContent = checked.value || swatchLabel?.textContent?.trim() || '';

  if (preview && swatchLabel instanceof HTMLElement) {
    const imgVar = swatchLabel.style.getPropertyValue('--option-color-image');
    if (imgVar) preview.style.setProperty('--option-color-image', imgVar);
  }
}

function filterLeathersByGrade(root) {
  const fs = root.querySelector('[data-leather-picker]');
  if (!fs) return;

  const wanted = getSelectedGradePrefix(root);
  if (!wanted) return;

  const inputs = Array.from(fs.querySelectorAll('input[type="radio"]'));
  let firstMatch = null;

  inputs.forEach((inp) => {
    const match = inp.dataset.gradePrefix === wanted;
    const label = inp.nextElementSibling;
    if (match && !firstMatch) firstMatch = inp;

    // hide + disable non-matching
    inp.disabled = !match;
    if (label && label.tagName === 'LABEL') {
      label.classList.toggle('is-hidden', !match);
    }
  });

  const checked = fs.querySelector('input[type="radio"]:checked');
  if (!checked || checked.disabled) {
    if (firstMatch) {
      firstMatch.checked = true;
    }
  }

  updateLeatherPreview(root);
}


function parseMoneyToCents(text) {
  if (!text) return null;

  // Remove everything except digits, commas, dots, minus
  const cleaned = text.replace(/[^\d.,-]/g, '').trim();
  if (!cleaned) return null;

  // If it looks like "1,234.56" -> remove commas
  // If it looks like "1.234,56" -> treat comma as decimal (best-effort)
  const hasDot = cleaned.includes('.');
  const hasComma = cleaned.includes(',');

  let normalized = cleaned;
  if (hasDot && hasComma) {
    // assume commas are thousand separators
    normalized = cleaned.replace(/,/g, '');
  } else if (!hasDot && hasComma) {
    // assume comma is decimal separator
    normalized = cleaned.replace(',', '.');
  }

  const value = Number(normalized);
  if (Number.isNaN(value)) return null;

  return Math.round(value * 100);
}

function formatCentsToMoney(cents) {
  // Uses browser locale/currency if available; otherwise fallback.
  try {
    // If you know currency, set it explicitly (e.g. 'USD')
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD' }).format(cents / 100);
  } catch {
    return `$${(cents / 100).toFixed(2)}`;
  }
}

function updateArrangementSubtotal(root = document) {
  const subtotalEl = root.querySelector('[data-arrangement-subtotal]');
  if (!subtotalEl) return;

  // Sum the prices of the selected arrangements (from the tile labels)
  let totalCents = 0;
  let anyMissing = false;

  selectedArrangementIds.forEach((arrId) => {
    const cb = root.querySelector(
      `fieldset[data-index="option2"] input[type="checkbox"][data-option-value-id="${CSS.escape(arrId)}"]`
    );
    const label = cb?.nextElementSibling;
    const priceText = label?.querySelector?.('[data-arrangement-price]')?.textContent?.trim();

    const cents = parseMoneyToCents(priceText);
    if (cents == null) {
      anyMissing = true;
      return;
    }
    totalCents += cents * getArrangementQty(arrId);

  });

  if (selectedArrangementIds.size === 0) {
    subtotalEl.innerHTML = '&nbsp;'; // if you need it to keep height
    return;
  }

  subtotalEl.textContent = anyMissing ? '—' : formatCentsToMoney(totalCents);
}

const arrangementQtyById = new Map(); // optionValueId -> qty (int)

function getArrangementQty(optionValueId) {
  return arrangementQtyById.get(optionValueId) ?? 1;
}

function setArrangementQty(optionValueId, qty) {
  arrangementQtyById.set(optionValueId, Math.max(1, parseInt(qty, 10) || 1));
}

function restoreArrangementQtyUI(root) {
  root.querySelectorAll('[data-qty-input]').forEach((input) => {
    const label = input.closest('.arrangement_label');
    const cb = label?.previousElementSibling;
    const id = cb?.dataset?.optionValueId;
    if (!id) return;

    // seed
    if (!arrangementQtyById.has(id)) arrangementQtyById.set(id, 1);

    const qty = getArrangementQty(id);

    // force it
    input.value = String(qty);
    input.setAttribute('value', String(qty)); // helps after swaps
  });
}




// Persist selected arrangements across section swaps
const selectedArrangementIds = new Set();

function captureArrangementSelections(root) {
  root.querySelectorAll('fieldset[data-index="option2"] input[type="checkbox"][data-option-value-id]').forEach(cb => {
    const id = cb.dataset.optionValueId;
    if (!id) return;
    if (cb.checked) selectedArrangementIds.add(id);
    else selectedArrangementIds.delete(id);
  });
}

function restoreArrangementSelections(root) {
  root.querySelectorAll('fieldset[data-index="option2"] input[type="checkbox"][data-option-value-id]').forEach(cb => {
    const id = cb.dataset.optionValueId;
    if (!id) return;
    // don't re-check disabled
    cb.checked = selectedArrangementIds.has(id) && !cb.disabled;
  });
}


async function updateArrangementPrices(sectionRoot) {
  const picker = sectionRoot.querySelector('.optionValueSelectors');
  if (!picker) return;

  const sectionId = picker.dataset.sectionId;
  const productUrl = picker.dataset.productUrl || window.location.pathname;

  const gradeChecked = sectionRoot.querySelector(
    'fieldset[data-index="option1"] input[type="radio"]:checked'
  );

  const arrangementInputs = getArrangementInputs(sectionRoot); // ✅ both radio + checkbox
  const mode = getArrangementMode(sectionRoot);

  if (!gradeChecked?.dataset.optionValueId) return;
  if (mode === 'none') return;

  const gradeId = gradeChecked.dataset.optionValueId;


  arrangementInputs.forEach((inp) => {
    inp.dataset.variantId = '';
    inp.dataset.priceCents = '';
    inp.dataset.compareCents = '';
    const label = inp.nextElementSibling;
    const compareEl = label?.querySelector?.('[data-arrangement-compare-price]');
    if (compareEl) compareEl.textContent = '…';
    const priceEl = label?.querySelector?.('[data-arrangement-price]');
    if (priceEl) priceEl.textContent = '…';
  });

  await Promise.all(arrangementInputs.map(async (arrInp) => {
    const arrId = arrInp.dataset.optionValueId;
    const label = arrInp.nextElementSibling;
    const priceEl = label?.querySelector?.('[data-arrangement-price]');
    const compareEl = label?.querySelector?.('[data-arrangement-compare-price]');
    if (!priceEl) return;

    const url = `${productUrl}?section_id=${sectionId}&option_values=${gradeId},${arrId}`;

    try {
      let htmlText = htmlCache.get(url);
      if (!htmlText) {
        const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        htmlText = await res.text();
        htmlCache.set(url, htmlText);
      }

      const doc = new DOMParser().parseFromString(htmlText, 'text/html');

      // price hook
      const hook = doc.querySelector(`#shopify-section-${sectionId} .js-variant-price`);
      console.log('arr price hook dataset:', hook?.dataset);

      const formatted = hook?.dataset?.priceFormatted;
      if (formatted) priceEl.textContent = formatted;
      else {
        const priceContainer = doc.getElementById(`price-${sectionId}`);
        priceEl.textContent = priceContainer ? priceContainer.textContent.trim() : '—';
      }
      const comparepriceFormatted = hook?.dataset?.compareFormatted;
      if(comparepriceFormatted) compareEl.textContent = comparepriceFormatted;
      else {
        compareEl.textContent = '-';
      }
      // cents for subtotal/savings (optional but useful)
      const priceCents = hook?.dataset?.priceCents ? Number(hook.dataset.priceCents) : null;
      const compareRaw = hook?.dataset?.compareCents ? Number(hook.dataset.compareCents) : null;
      const compareCents = (compareRaw != null && priceCents != null && compareRaw > priceCents) ? compareRaw : null;


      arrInp.dataset.priceCents = priceCents != null ? String(priceCents) : '';
      arrInp.dataset.compareCents = compareCents != null ? String(compareCents) : '';

      // variant id
      const variantId =
        doc.querySelector(`#shopify-section-${sectionId} form[action*="/cart/add"] input[name="id"]`)?.value;

      const atcDisabled =
        doc.querySelector(`#shopify-section-${sectionId} button[name="add"]`)?.disabled ?? false;

      if (!variantId || atcDisabled) {
        arrInp.disabled = true;
        arrInp.checked = false;
        arrInp.dataset.variantId = '';
        priceEl.textContent = '—';

        // ✅ only mutate the Set in multi-mode
        if (mode === 'multi') selectedArrangementIds.delete(arrId);
      } else {
        arrInp.disabled = false;
        arrInp.dataset.variantId = variantId;
      }
    } catch (e) {
      arrInp.disabled = true;
      arrInp.checked = false;
      arrInp.dataset.variantId = '';
      priceEl.textContent = '—';
      if (mode === 'multi') selectedArrangementIds.delete(arrId);
    }
  }));

  // ✅ render summary based on mode
  renderMultiVariantSummary(sectionRoot);
}


function setFirstEnabledLeatherChecked(sectionEl) {
  const leatherFs = sectionEl.querySelector('fieldset[data-index="option2"]');
  if (!leatherFs) return false;

  const checked = leatherFs.querySelector('input[type="radio"]:checked');
  if (checked && !checked.disabled) return false; // already valid

  const firstEnabled = Array.from(leatherFs.querySelectorAll('input[type="radio"]'))
    .find(i => !i.disabled);

  if (!firstEnabled) return false;

  firstEnabled.checked = true;
  return true;
}

let pdpUpdateDepth = 0;

function beginPdpUpdate() {
  pdpUpdateDepth += 1;
  document.documentElement.classList.add('pdp-updating');
}

function endPdpUpdate() {
  pdpUpdateDepth = Math.max(0, pdpUpdateDepth - 1);
  if (pdpUpdateDepth === 0) {
    document.documentElement.classList.remove('pdp-updating');
  }
}

function renderMultiVariantSummary(root = document) {
  const summaryEl = root.querySelector('[data-variant-summary]');
  if (!summaryEl) return;

  const getCheckedValue = (index) =>
    root.querySelector(`fieldset[data-index="option${index}"] input[type="radio"]:checked`)?.value || '';

  const grade = getCheckedValue(1);

  const leatherRaw =
    root.querySelector('[data-leather-picker] input[type="radio"]:checked')?.value || '';

  // Optional: display without the trailing "(25VM)" code
  const leather = leatherRaw.replace(/\s*\([^)]+\)\s*$/, '').trim();


  // Arrangement checkboxes (option3) — use persisted set
    const mode = getArrangementMode(root);

  const arrangementIds =
    (mode === 'multi')
      ? Array.from(selectedArrangementIds)
      : Array.from(getSelectedArrangementIds(root)); // ✅ radio-derived

  const arrangements = arrangementIds.map((arrId) => {
    const inp = root.querySelector(
      `fieldset[data-index="option2"] input[data-option-value-id="${CSS.escape(arrId)}"]`
    );
    const label = inp?.nextElementSibling;

    const name =
      label?.querySelector?.('.arrangement_title')?.textContent?.trim() ||
      label?.textContent?.trim() ||
      inp?.value ||
      'Arrangement';

    const qty = (mode === 'multi') ? getArrangementQty(arrId) : 1;
    const qtySuffix = qty > 1 ? ` (qt. ${qty})` : '';

    return `${name}${qtySuffix}`;
  });




  let html = '';
  if (grade) html += `<span class="arrangement_summary">Grade:</span> ${escapeHtml(grade)}<br>`;
  if (leather) html += `<span class="arrangement_summary">Color:</span> ${escapeHtml(leatherRaw)}<br>`;

  if (arrangements.length) {
    arrangements.forEach((line) => {
      html += `<span class="arrangement_summary">Arrangement:</span> ${escapeHtml(line)}<br>`;
    });
  } else {
    //html += `<span class="arrangement_summary">Arrangement:</span>  <br>`;
  }

  summaryEl.innerHTML = html;
  updateArrangementSubtotal(root);
}

// tiny helper so names with & etc don’t break HTML
function escapeHtml(str) {
  return String(str)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
}

let inflightController = null;
const htmlCache = new Map();

function patchPriceAndATC(sectionId, fromSection, toSection) {
  // --- determine the new selected variant id from the fetched section ---
  const toVariantId =
    toSection.querySelector('form[action*="/cart/add"] input[name="id"]')?.value ||
    toSection.querySelector('form[action*="/cart/add"] select[name="id"]')?.value ||
    '';

  const toPrice = toSection.querySelector(`#price-${CSS.escape(sectionId)}`);
  if (toPrice) {
    const targets = document.querySelectorAll(`#price-${CSS.escape(sectionId)}`);
    targets.forEach((fromPrice) => {
      fromPrice.innerHTML = toPrice.innerHTML;
    });
  }

  if (!toVariantId) return '';

  // --- PATCH EVERY relevant /cart/add form (not just the first) ---
  // scope: current product section + common “sticky” areas if your theme has them
  const scopes = [
    fromSection,
    document.querySelector('.product-add-to-cart-container'),
    document.querySelector('.add_to_cart_holder'),
    document
  ].filter(Boolean);

  const seen = new Set();
  scopes.forEach(scope => {
    scope.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      if (seen.has(form)) return;
      seen.add(form);

      // update input[name="id"]
      const idInput = form.querySelector('input[name="id"]');
      if (idInput) {
        idInput.value = String(toVariantId);
        idInput.setAttribute('value', String(toVariantId));
        idInput.dispatchEvent(new Event('input', { bubbles: true }));
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // update select[name="id"] (some themes/apps watch this)
      const idSelect = form.querySelector('select[name="id"]');
      if (idSelect) {
        // ensure the option exists
        let opt = Array.from(idSelect.options).find(o => o.value === String(toVariantId));
        if (!opt) {
          opt = document.createElement('option');
          opt.value = String(toVariantId);
          opt.textContent = String(toVariantId);
          idSelect.appendChild(opt);
        }
        idSelect.value = String(toVariantId);
        idSelect.dispatchEvent(new Event('input', { bubbles: true }));
        idSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // keep button disabled/state aligned if your fetched section changed it
      const toForm = toSection.querySelector('form[action*="/cart/add"]');
      if (toForm) {
        const toBtn = toForm.querySelector('button[name="add"], #AddToCart');
        const fromBtn = form.querySelector('button[name="add"], #AddToCart');
        if (toBtn && fromBtn) {
          fromBtn.disabled = toBtn.disabled;
          fromBtn.className = toBtn.className;
          fromBtn.innerHTML = toBtn.innerHTML;
        }
      }

      // some apps sniff these:
      form.dataset.variantId = String(toVariantId);
    });
  });

  // URL variant param (apps often use this as “current variant”)
  try {
    const u = new URL(window.location.href);
    u.searchParams.set('variant', String(toVariantId));
    history.replaceState({}, '', u.toString());
  } catch {}

  // broadcast events apps commonly listen for
  const detail = { variant: { id: Number(toVariantId) } };
  document.dispatchEvent(new CustomEvent('variant:change', { detail }));
  window.dispatchEvent(new CustomEvent('variant:change', { detail }));

  return toVariantId;
}



function patchOptionDisabledStates(fromSection, toSection) {
  // Copy disabled state for leather radios based on what server returned
  const fromInputs = fromSection.querySelectorAll('fieldset[data-index="option2"] input[type="radio"][data-option-value-id]');
  fromInputs.forEach(fromInp => {
    const id = fromInp.dataset.optionValueId;
    if (!id) return;
    const toInp = toSection.querySelector(`fieldset[data-index="option2"] input[type="radio"][data-option-value-id="${CSS.escape(id)}"]`);
    if (!toInp) return;

    fromInp.disabled = toInp.disabled;

    // If you hide labels via CSS class, keep that in sync
    const fromLabel = fromInp.nextElementSibling;
    if (fromLabel && fromLabel.tagName === 'LABEL') {
      fromLabel.classList.toggle('is-hidden', fromInp.disabled);
    }
  });
}

function notifyVariantChanged(root, variantId) {
  if (!variantId) return;

  // Make sure ALL live forms have the variant id set (again, harmless)
  root.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    const idInput = form.querySelector('input[name="id"]');
    const idSelect = form.querySelector('select[name="id"]');

    if (idInput) {
      idInput.value = variantId;
      idInput.setAttribute('value', variantId);
      idInput.dispatchEvent(new Event('input', { bubbles: true }));
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (idSelect) {
      idSelect.value = variantId;
      Array.from(idSelect.options).forEach(opt => opt.selected = (opt.value === variantId));
      idSelect.dispatchEvent(new Event('input', { bubbles: true }));
      idSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    form.dataset.variantId = variantId;
  });

  const detail = { variantId, variant: { id: Number(variantId) } };

  // Common theme/app CustomEvents
  document.dispatchEvent(new CustomEvent('variant:change', { detail }));
  document.dispatchEvent(new CustomEvent('variant:changed', { detail }));
  document.dispatchEvent(new CustomEvent('theme:variant:change', { detail }));
  document.dispatchEvent(new CustomEvent('shopify:variant:change', { detail }));

  // Some apps listen on window
  window.dispatchEvent(new CustomEvent('variant:change', { detail }));
  window.dispatchEvent(new CustomEvent('shopify:variant:change', { detail }));

  // Older apps use jQuery hooks
  if (window.jQuery) {
    window.jQuery(document).trigger('variant:change', [detail.variant]);
    window.jQuery(document).trigger('variant:changed', [detail.variant]);
    window.jQuery(document).trigger('shopify:variant:change', [detail.variant]);
  }
}

function setVariantInUrl(productUrl, variantId) {
  if (!variantId) return;
  try {
    const u = new URL(productUrl, window.location.origin);
    u.searchParams.set('variant', String(variantId));

    // keep existing query params on current page too
    const current = new URL(window.location.href);
    current.searchParams.set('variant', String(variantId));
    history.replaceState({}, '', current.toString());
  } catch (e) {}
}

function ensureIdSelectSynced(root, variantId) {
  if (!variantId) return;

  root.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    let idSelect = form.querySelector('select[name="id"]');
    const idInput = form.querySelector('input[name="id"]');

    // If there is no select, create one (hidden) so apps can bind to it
    if (!idSelect) {
      idSelect = document.createElement('select');
      idSelect.name = 'id';
      idSelect.setAttribute('hidden', '');
      idSelect.style.display = 'none';

      // If you can’t easily populate options, still create the select
      // and inject a single option for the currently selected variant.
      const opt = document.createElement('option');
      opt.value = String(variantId);
      opt.textContent = String(variantId);
      opt.selected = true;
      idSelect.appendChild(opt);

      form.appendChild(idSelect);
    } else {
      // Make sure the option exists
      let opt = Array.from(idSelect.options).find(o => o.value === String(variantId));
      if (!opt) {
        opt = document.createElement('option');
        opt.value = String(variantId);
        opt.textContent = String(variantId);
        idSelect.appendChild(opt);
      }
      idSelect.value = String(variantId);
      Array.from(idSelect.options).forEach(o => (o.selected = (o.value === String(variantId))));
    }

    // Always keep the input in sync too
    if (idInput) {
      idInput.value = String(variantId);
      idInput.setAttribute('value', String(variantId));
    }

    // Fire events apps typically watch
    idSelect.dispatchEvent(new Event('input', { bubbles: true }));
    idSelect.dispatchEvent(new Event('change', { bubbles: true }));
    if (idInput) {
      idInput.dispatchEvent(new Event('input', { bubbles: true }));
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
}

function getVariantPayloadFromSection(sectionEl) {
  // Many themes render JSON in a script tag; if yours does, prefer that.
  const jsonEl = sectionEl.querySelector('[type="application/json"][data-selected-variant], [data-variant-json]');
  if (jsonEl) {
    try { return JSON.parse(jsonEl.textContent); } catch (e) {}
  }

  // Fallback: at least provide id + price formatted
  const id =
    sectionEl.querySelector('form[action*="/cart/add"] input[name="id"]')?.value ||
    sectionEl.querySelector('form[action*="/cart/add"] select[name="id"]')?.value;

  const hook = sectionEl.querySelector('.js-variant-price');
  const priceFormatted = hook?.dataset?.priceFormatted;

  return id ? { id: Number(id), priceFormatted } : null;
}

function dispatchVariantChange(variant) {
  if (!variant?.id) return;
  const detail = { variant };

  document.dispatchEvent(new CustomEvent('variant:change', { detail }));
  window.dispatchEvent(new CustomEvent('variant:change', { detail }));

  if (window.jQuery) window.jQuery(document).trigger('variant:change', [variant]);
}

function patchAnalyticsSelectedVariant(variantId) {
  if (!variantId) return;
  try {
    window.ShopifyAnalytics = window.ShopifyAnalytics || {};
    window.ShopifyAnalytics.meta = window.ShopifyAnalytics.meta || {};
    window.ShopifyAnalytics.meta.selectedVariantId = Number(variantId);
  } catch (e) {}
}




async function refreshProductSection(changedInput) {
  const picker = changedInput.closest('.optionValueSelectors');
  if (!picker) return;

  const sectionId = picker.dataset.sectionId;
  const productUrl = picker.dataset.productUrl || window.location.pathname;
  if (!sectionId) return;

  // Abort any in-flight request
  if (inflightController) inflightController.abort();
  inflightController = new AbortController();

  const currentSection = document.getElementById(`shopify-section-${sectionId}`);
  if (!currentSection) return;

  // Turn on "updating" (this is what hides the price via your CSS)
  beginPdpUpdate();
  currentSection.classList.add('is-updating');

  try {
    // Collect selected option_value ids (grade/leather/arrangement)
    /*const selectedIds = Array.from(
      picker.querySelectorAll('input[type="radio"]:checked')
    ).map(el => el.dataset.optionValueId).filter(Boolean);*/

    const sectionRoot = changedInput.closest('[id^="shopify-section-"]') || document;

    // Collect checked radios from option1, option2, and (if single-mode) option3
    const selectedIds = Array.from(
      sectionRoot.querySelectorAll('fieldset[data-index="option1"] input[type="radio"]:checked, fieldset[data-index="option2"] input[type="radio"]:checked')
    ).map(el => el.dataset.optionValueId).filter(Boolean);


    const url = `${productUrl}?section_id=${sectionId}${
      selectedIds.length ? `&option_values=${selectedIds.join(',')}` : ''
    }`;

    let htmlText = htmlCache.get(url);
    if (!htmlText) {
      const res = await fetch(url, {
        signal: inflightController.signal,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      htmlText = await res.text();
      htmlCache.set(url, htmlText);
    }

    let doc = new DOMParser().parseFromString(htmlText, 'text/html');
    let newSection = doc.getElementById(`shopify-section-${sectionId}`);
    if (!newSection) return;

    // 2) Pre-pick the first enabled leather in the RESPONSE
    /*if (setFirstEnabledLeatherChecked(newSection)) {
    const picker2 = newSection.querySelector('.optionValueSelectors');
    const selectedIds2 = Array.from(
        picker2.querySelectorAll('input[type="radio"]:checked')
    ).map(el => el.dataset.optionValueId).filter(Boolean);

    const url2 = `${productUrl}?section_id=${sectionId}${
        selectedIds2.length ? `&option_values=${selectedIds2.join(',')}` : ''
    }`;

    // Fetch the fully-stable HTML (grade + valid leather)
    let htmlText2 = htmlCache.get(url2);
    if (!htmlText2) {
        const res2 = await fetch(url2, { signal: inflightController.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' }});
        htmlText2 = await res2.text();
        htmlCache.set(url2, htmlText2);
    }

    doc = new DOMParser().parseFromString(htmlText2, 'text/html');
    newSection = doc.getElementById(`shopify-section-${sectionId}`);
    if (!newSection) return;
    }*/

    const newVariantId = patchPriceAndATC(sectionId, currentSection, newSection);
    //patchOptionDisabledStates(currentSection, newSection);
    ensureIdSelectSynced(currentSection, newVariantId);
    setVariantInUrl(productUrl, newVariantId);
    patchAnalyticsSelectedVariant(newVariantId);


    const variantPayload = getVariantPayloadFromSection(newSection);
    dispatchVariantChange(variantPayload);

    /*if (autoSelectFirstEnabledLeather(currentSection)) {
      // if this triggers, call refreshProductSection again using the checked leather input
      const checkedLeather = currentSection.querySelector('fieldset[data-index="option2"] input[type="radio"]:checked');
      if (checkedLeather) refreshProductSection(checkedLeather);
      return;
    }*/

    // Replace section
    //currentSection.replaceWith(newSection);

    // restore arrangement checks in the newly injected DOM
    restoreArrangementSelections(currentSection);
    restoreArrangementQtyUI(currentSection);
    renderMultiVariantSummary(currentSection);

    /*hideDisabledLeathers(currentSection);*/
    updateArrangementPrices(currentSection);
    filterLeathersByGrade(currentSection);
    initHoverDisplay(currentSection);

    // If leather is now invalid, select first enabled leather and re-fetch once
    /*const leatherFieldset = newSection.querySelector('fieldset[data-index="option2"]');
    if (leatherFieldset) {
      const checkedLeather = leatherFieldset.querySelector('input[type="radio"]:checked');
      if (!checkedLeather || checkedLeather.disabled) {
        const firstEnabled = Array.from(leatherFieldset.querySelectorAll('input[type="radio"]'))
          .find(i => !i.disabled);

        if (firstEnabled) {
          // Set it WITHOUT dispatching change (we'll re-fetch ourselves)
          firstEnabled.checked = true;

          const picker2 = newSection.querySelector('.optionValueSelectors');
          const selectedIds2 = Array.from(
            picker2.querySelectorAll('input[type="radio"]:checked')
          ).map(el => el.dataset.optionValueId).filter(Boolean);

          const url2 = `${productUrl}?section_id=${sectionId}${
            selectedIds2.length ? `&option_values=${selectedIds2.join(',')}` : ''
          }`;

          let htmlText2 = htmlCache.get(url2);
          if (!htmlText2) {
            const res2 = await fetch(url2, {
              signal: inflightController.signal,
              headers: { 'X-Requested-With': 'XMLHttpRequest' }
            });
            htmlText2 = await res2.text();
            htmlCache.set(url2, htmlText2);
          }

          const doc2 = new DOMParser().parseFromString(htmlText2, 'text/html');
          const newSection2 = doc2.getElementById(`shopify-section-${sectionId}`);
          if (newSection2) {

            newSection.replaceWith(newSection2);

            hideDisabledLeathers(newSection2);

            // restore and re-run everything on the final section
            restoreArrangementSelections(newSection2);
            updateArrangementSubtotal(newSection2);
            restoreArrangementQtyUI(newSection2);
            updateArrangementPrices(newSection2);
            initHoverDisplay(newSection2);
            renderMultiVariantSummary(newSection2);
          }

        }
      }
    }*/
  } catch (err) {
    if (err?.name !== 'AbortError') console.error(err);
  } finally {
    // Always turn UI back on
    const sec = document.getElementById(`shopify-section-${sectionId}`);
    sec?.classList.remove('is-updating');
    endPdpUpdate();
  }
}



/* async function refreshProductSection(changedInput) {
  const picker = changedInput.closest('.optionValueSelectors');
  if (!picker) return;

  const sectionId = picker.dataset.sectionId;
  const productUrl = picker.dataset.productUrl || window.location.pathname;

  const selectedOptionValueIds = Array.from(
    picker.querySelectorAll('input[type="radio"]:checked')
  ).map((el) => el.dataset.optionValueId).filter(Boolean);

  const params = selectedOptionValueIds.length
    ? `&option_values=${selectedOptionValueIds.join(',')}`
    : '';

  const res = await fetch(`${productUrl}?section_id=${sectionId}${params}`, {
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  });

  const htmlText = await res.text();
  const doc = new DOMParser().parseFromString(htmlText, 'text/html');

  const newSection = doc.getElementById(`shopify-section-${sectionId}`);
  const currentSection = document.getElementById(`shopify-section-${sectionId}`);

  if (!newSection || !currentSection) return;

  currentSection.replaceWith(newSection);

  // After swap, hide disabled leather swatches
    // hideDisabledLeathers(newSection);

    // If leather selection became invalid after changing grade,
    // auto-pick the first available leather and refresh once more.
    if (autoSelectFirstEnabledLeather(newSection)) {
    const newlyCheckedLeather = newSection.querySelector('fieldset[data-index="option2"] input[type="radio"]:checked');
    if (newlyCheckedLeather) {
        refreshProductSection(newlyCheckedLeather);
    }
    }
} */

document.addEventListener('change', (e) => {
  const input = e.target;
  if (!(input instanceof HTMLInputElement)) return;
  const root = input.closest?.('[id^="shopify-section-"]') || document;

  // If it's the non-variant leather picker, update preview + sidebar summary
  if (input.closest('[data-leather-picker]') && input.type === 'radio') {
    updateLeatherPreview(root);
    renderMultiVariantSummary(root);
    return;
  }
  if (!input.dataset.optionValueId) return;

  const isArrangement = input.closest('fieldset')?.getAttribute('data-index') === 'option2';

  // Option 3 handling (both modes)
  if (isArrangement) {
    const mode = getArrangementMode(root);

    if (mode === 'multi' && input.type === 'checkbox') {
      captureArrangementSelections(root);

      if (input.checked) {
        const id = input.dataset.optionValueId;
        if (id && !arrangementQtyById.has(id)) arrangementQtyById.set(id, 1);

        const qtyInput = input.nextElementSibling?.querySelector?.('[data-qty-input]');
        if (qtyInput) {
          qtyInput.value = String(getArrangementQty(id));
          qtyInput.defaultValue = qtyInput.value;
        }
      }

      renderMultiVariantSummary(root);
      return;
    }

    if (mode === 'single' && input.type === 'radio') {
      // single arrangement behaves like normal variant option -> refresh section
      const isGrade = input.closest('fieldset')?.getAttribute('data-index') === 'option1';
      if (isGrade) filterLeathersByGrade(root);
      refreshProductSection(input);
      renderMultiVariantSummary(root);
      return;
    }
  }

  // Radios (grade/leather) still trigger section refresh
  if (input.type === 'radio') {
    refreshProductSection(input);
    renderMultiVariantSummary(root);
  }
});


document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-qty-minus],[data-qty-plus]');
  if (!btn) return;

  const label = btn.closest('.arrangement_label');
  if (!label) return;

  const checkbox = label.previousElementSibling;
  if (!(checkbox instanceof HTMLInputElement)) return;
  if (checkbox.type !== 'checkbox') return;

  // Only active when selected
  if (!checkbox.checked) return;

  const id = checkbox.dataset.optionValueId;
  if (!id) return;

  const input = label.querySelector('[data-qty-input]');
  if (!(input instanceof HTMLInputElement)) return;

  const current = parseInt(input.value || '1', 10) || 1;

    // ✅ NEW: if user hits minus at qty 1 => deselect arrangement
    if (btn.hasAttribute('data-qty-minus') && current <= 1) {
      // reset qty to 1 for next time they select it
      input.value = '1';
      input.setAttribute('value', '1');
      setArrangementQty(id, 1);

      // uncheck + notify your existing checkbox change logic
      checkbox.checked = false;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

  const next = btn.hasAttribute('data-qty-plus') ? current + 1 : Math.max(1, current - 1);

  input.value = String(next);
  setArrangementQty(id, next);

  // update summary/subtotal live
  const root = label.closest('[id^="shopify-section-"]') || document;
  renderMultiVariantSummary(root);
  updateArrangementSubtotal(root);
}, true);

document.addEventListener('input', (e) => {
  const input = e.target;
  if (!(input instanceof HTMLInputElement)) return;
  if (!input.matches('[data-qty-input]')) return;

  const label = input.closest('.arrangement_label');
  const checkbox = label?.previousElementSibling;
  if (!(checkbox instanceof HTMLInputElement)) return;
  if (!checkbox.checked) return;

  const id = checkbox.dataset.optionValueId;
  if (!id) return;

  setArrangementQty(id, input.value);

  const root = input.closest('[id^="shopify-section-"]') || document;
  renderMultiVariantSummary(root);
  updateArrangementSubtotal(root);
}, true);


function buildFormDataForVariant(form, variantId, qty) {
  const base = new FormData(form);
  const fd = new FormData();

  // Copy everything the app/theme injected (properties, hidden fields, etc)
  // but override id + quantity per item.
  for (const [key, val] of base.entries()) {
    if (key === 'id' || key === 'quantity') continue;
    fd.append(key, val);
  }

  fd.set('id', String(variantId));
  fd.set('quantity', String(qty));
  return fd;
}

document.addEventListener('submit', async (e) => {
  const form = e.target;
  if (!(form instanceof HTMLFormElement)) return;
  if (!form.matches('form[action*="/cart/add"]')) return;

  const root = form.closest('[id^="shopify-section-"]') || document;
  const mode = getArrangementMode(root);

  // Only intercept for A La Carte (multi)
  if (mode !== 'multi') return;

  const arrangementChecks = Array.from(
    root.querySelectorAll('fieldset[data-index="option2"] input[type="checkbox"][data-option-value-id]:checked')
  );

  // If none checked, let normal add-to-cart happen (and app works normally)
  if (arrangementChecks.length === 0) return;

  // stop the theme/app default add-to-cart flow (we will re-submit via AJAX)
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  // Build items from checked arrangements
  const items = arrangementChecks
    .map(cb => {
      const vid = cb.dataset.variantId;
      if (!vid) return null;
      const qty = getArrangementQty(cb.dataset.optionValueId);
      return { id: String(vid), quantity: qty };
    })
    .filter(Boolean);

  if (items.length === 0) {
    alert('Please select an available arrangement.');
    return;
  }

  try {
    // Submit once per item so we preserve ALL app-provided form fields/properties
    // (JSON multi-add drops them unless you rebuild them yourself)
    for (const item of items) {
      const fd = buildFormDataForVariant(form, item.id, item.quantity);

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: fd
      });

      if (!res.ok) {
        let err = {};
        try { err = await res.json(); } catch {}
        console.error('Add failed for', item, err);
        throw new Error('add_failed');
      }
    }

    // redirect or open cart drawer
    window.location.href = '/cart';
  } catch {
    alert('Could not add the selected arrangements. Please try again.');
  }
}, true);

// Initial hide on page load
document.addEventListener('DOMContentLoaded', () => {
  const main = document.querySelector('[class~="optionValueSelectors"]')?.closest('[id^="shopify-section-"]') || document;
  //hideDisabledLeathers(main);
  updateArrangementPrices(main);
  initHoverDisplay(main);
  const root = document.querySelector('.optionValueSelectors')?.closest('[id^="shopify-section-"]') || document;
  restoreArrangementQtyUI(root);
  filterLeathersByGrade(document);
  updateLeatherPreview(document);
  renderMultiVariantSummary(root);
});

function initHoverDisplay(root = document) {
    // --- Leather picker hover preview (non-variant) ---
  root.querySelectorAll('fieldset[data-leather-picker]').forEach((fieldset) => {
    const nameEl = fieldset.querySelector('[data-leather-display]');
    const previewEl = fieldset.querySelector('[data-leather-preview]');
    if (!nameEl && !previewEl) return;

    const getChecked = () => fieldset.querySelector('input[type="radio"]:checked');

    const getLabelForInput = (input) => {
      if (!input) return null;
      const lbl = input.nextElementSibling;
      return (lbl && lbl.tagName === 'LABEL') ? lbl : null;
    };

    const applyFrom = (input, lbl) => {
      if (!input || !lbl) return;

      // Ignore hidden/disabled options
      if (input.disabled) return;
      if (lbl.classList?.contains('is-hidden')) return;

      // 1) text (show hovered name)
      if (nameEl) nameEl.textContent = (input.value || lbl.textContent || '').trim();

      // 2) preview image (copy CSS var from label)
      if (previewEl) {
        const imgVar = lbl.style.getPropertyValue('--option-color-image');
        if (imgVar) {
          previewEl.style.setProperty('--option-color-image', imgVar.trim());
        } else {
          const computed = getComputedStyle(lbl).getPropertyValue('--option-color-image');
          if (computed) previewEl.style.setProperty('--option-color-image', computed.trim());
        }
      }
    };

    const applySelected = () => {
      const checked = getChecked();
      applyFrom(checked, getLabelForInput(checked));
    };

    // Hover: update to hovered swatch
    fieldset.addEventListener(
      'mouseenter',
      (e) => {
        const lbl = e.target.closest('label');
        if (!lbl || !fieldset.contains(lbl)) return;

        const input = lbl.previousElementSibling;
        if (!(input instanceof HTMLInputElement)) return;

        applyFrom(input, lbl);
      },
      true
    );

    // Leave: revert to selected
    fieldset.addEventListener('mouseleave', () => {
      applySelected();
    });

    // Change: if user selects, make that the “selected” baseline
    fieldset.addEventListener('change', () => {
      applySelected();
    });

    // Initial
    applySelected();
  });
}

function getFieldset(root, optionIndex) {
  return root.querySelector(`fieldset[data-index="option${optionIndex}"]`);
}

function autoSelectFirstEnabledLeather(root) {
  // Option 2 = Leather
  const leatherFieldset = getFieldset(root, 2);
  if (!leatherFieldset) return false;

  const checked = leatherFieldset.querySelector('input[type="radio"]:checked');
  if (checked && !checked.disabled) return false; // already valid

  const firstEnabled = Array.from(leatherFieldset.querySelectorAll('input[type="radio"]'))
    .find((i) => !i.disabled);

  if (!firstEnabled) return false;

  firstEnabled.checked = true;
  firstEnabled.dispatchEvent(new Event('input', { bubbles: true }));
  firstEnabled.dispatchEvent(new Event('change', { bubbles: true }));
  return true;
}